@file:OptIn(InternalResourceApi::class)

package thewedding_cmp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/thewedding_cmp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-785_428_352)
internal val Res.string.animatedArrowSemanticSwipe: StringResource by lazy {
      StringResource("string:animatedArrowSemanticSwipe", "animatedArrowSemanticSwipe", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 126),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 70),
      ))
    }

@delegate:ResourceContentHash(1_275_814_325)
internal val Res.string.appBarTitleConstruction: StringResource by lazy {
      StringResource("string:appBarTitleConstruction", "appBarTitleConstruction", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 137, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 93, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81, 51),
      ))
    }

@delegate:ResourceContentHash(-1_479_167_775)
internal val Res.string.appBarTitleFactsHistory: StringResource by lazy {
      StringResource("string:appBarTitleFactsHistory", "appBarTitleFactsHistory", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 189, 43),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 145, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133, 43),
      ))
    }

@delegate:ResourceContentHash(-200_826_091)
internal val Res.string.appBarTitleLocation: StringResource by lazy {
      StringResource("string:appBarTitleLocation", "appBarTitleLocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 233, 43),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 189, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177, 43),
      ))
    }

@delegate:ResourceContentHash(-2_094_608_933)
internal val Res.string.appModalsButtonCancel: StringResource by lazy {
      StringResource("string:appModalsButtonCancel", "appModalsButtonCancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 277, 65),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 233, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 221, 37),
      ))
    }

@delegate:ResourceContentHash(789_535_463)
internal val Res.string.appModalsButtonOk: StringResource by lazy {
      StringResource("string:appModalsButtonOk", "appModalsButtonOk", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 343, 49),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 271, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 259, 29),
      ))
    }

@delegate:ResourceContentHash(250_339_644)
internal val Res.string.appName: StringResource by lazy {
      StringResource("string:appName", "appName", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 393, 35),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 305, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289, 27),
      ))
    }

@delegate:ResourceContentHash(367_556_023)
internal val Res.string.appPageDefaultTitlePage: StringResource by lazy {
      StringResource("string:appPageDefaultTitlePage", "appPageDefaultTitlePage", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 429, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 337, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317, 39),
      ))
    }

@delegate:ResourceContentHash(-810_676_025)
internal val Res.string.appPageSemanticSwipe: StringResource by lazy {
      StringResource("string:appPageSemanticSwipe", "appPageSemanticSwipe", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 481, 76),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 373, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 357, 52),
      ))
    }

@delegate:ResourceContentHash(416_356_494)
internal val Res.string.artifactDetailsErrorNotFound: StringResource by lazy {
      StringResource("string:artifactDetailsErrorNotFound", "artifactDetailsErrorNotFound", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 558, 168),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 430, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 410, 88),
      ))
    }

@delegate:ResourceContentHash(-1_023_527_588)
internal val Res.string.artifactDetailsLabelClassification: StringResource by lazy {
      StringResource("string:artifactDetailsLabelClassification", "artifactDetailsLabelClassification", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 727, 74),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 511, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 499, 62),
      ))
    }

@delegate:ResourceContentHash(-1_498_496_799)
internal val Res.string.artifactDetailsLabelDate: StringResource by lazy {
      StringResource("string:artifactDetailsLabelDate", "artifactDetailsLabelDate", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 802, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 562, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 562, 40),
      ))
    }

@delegate:ResourceContentHash(177_502_857)
internal val Res.string.artifactDetailsLabelDimension: StringResource by lazy {
      StringResource("string:artifactDetailsLabelDimension", "artifactDetailsLabelDimension", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 855, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 603, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 603, 49),
      ))
    }

@delegate:ResourceContentHash(-49_772_343)
internal val Res.string.artifactDetailsLabelGeography: StringResource by lazy {
      StringResource("string:artifactDetailsLabelGeography", "artifactDetailsLabelGeography", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 909, 57),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 649, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 653, 49),
      ))
    }

@delegate:ResourceContentHash(-1_604_097_029)
internal val Res.string.artifactDetailsLabelMedium: StringResource by lazy {
      StringResource("string:artifactDetailsLabelMedium", "artifactDetailsLabelMedium", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 967, 58),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 703, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 703, 42),
      ))
    }

@delegate:ResourceContentHash(-319_077_883)
internal val Res.string.artifactDetailsLabelPeriod: StringResource by lazy {
      StringResource("string:artifactDetailsLabelPeriod", "artifactDetailsLabelPeriod", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1026, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 746, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 746, 42),
      ))
    }

@delegate:ResourceContentHash(1_314_823_880)
internal val Res.string.artifactDetailsSemanticThumbnail: StringResource by lazy {
      StringResource("string:artifactDetailsSemanticThumbnail", "artifactDetailsSemanticThumbnail", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1077, 80),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 789, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 789, 60),
      ))
    }

@delegate:ResourceContentHash(-584_330_698)
internal val Res.string.artifactsButtonBrowse: StringResource by lazy {
      StringResource("string:artifactsButtonBrowse", "artifactsButtonBrowse", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1158, 141),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 842, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 850, 57),
      ))
    }

@delegate:ResourceContentHash(1_900_126_406)
internal val Res.string.artifactsSearchButtonToggle: StringResource by lazy {
      StringResource("string:artifactsSearchButtonToggle", "artifactsSearchButtonToggle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1300, 99),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 896, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 908, 59),
      ))
    }

@delegate:ResourceContentHash(-178_513_831)
internal val Res.string.artifactsSearchLabelAdjust: StringResource by lazy {
      StringResource("string:artifactsSearchLabelAdjust", "artifactsSearchLabelAdjust", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1400, 102),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 956, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 968, 50),
      ))
    }

@delegate:ResourceContentHash(-167_605_641)
internal val Res.string.artifactsSearchLabelFound: StringResource by lazy {
      StringResource("string:artifactsSearchLabelFound", "artifactsSearchLabelFound", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1503, 125),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1007, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1019, 73),
      ))
    }

@delegate:ResourceContentHash(1_330_655_890)
internal val Res.string.artifactsSearchLabelNotFound: StringResource by lazy {
      StringResource("string:artifactsSearchLabelNotFound", "artifactsSearchLabelNotFound", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1629, 128),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1077, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1093, 60),
      ))
    }

@delegate:ResourceContentHash(14_510_930)
internal val Res.string.artifactsSearchLabelSearch: StringResource by lazy {
      StringResource("string:artifactsSearchLabelSearch", "artifactsSearchLabelSearch", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1758, 66),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1138, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1154, 50),
      ))
    }

@delegate:ResourceContentHash(-1_277_586_016)
internal val Res.string.artifactsSearchLabelTimeframe: StringResource by lazy {
      StringResource("string:artifactsSearchLabelTimeframe", "artifactsSearchLabelTimeframe", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1825, 69),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1185, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1205, 49),
      ))
    }

@delegate:ResourceContentHash(-1_277_586_016)
internal val Res.string.artifactsSearchSemanticTimeframe: StringResource by lazy {
      StringResource("string:artifactsSearchSemanticTimeframe", "artifactsSearchSemanticTimeframe", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1895, 72),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1239, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1255, 52),
      ))
    }

@delegate:ResourceContentHash(1_010_753_831)
internal val Res.string.artifactsSearchTitleBrowse: StringResource by lazy {
      StringResource("string:artifactsSearchTitleBrowse", "artifactsSearchTitleBrowse", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1968, 130),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1296, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1308, 58),
      ))
    }

@delegate:ResourceContentHash(-894_661_063)
internal val Res.string.artifactsSemanticArtifact: StringResource by lazy {
      StringResource("string:artifactsSemanticArtifact", "artifactsSemanticArtifact", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2099, 61),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1347, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1367, 45),
      ))
    }

@delegate:ResourceContentHash(-727_008_761)
internal val Res.string.artifactsSemanticsNext: StringResource by lazy {
      StringResource("string:artifactsSemanticsNext", "artifactsSemanticsNext", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2161, 78),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1389, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1413, 50),
      ))
    }

@delegate:ResourceContentHash(-914_780_972)
internal val Res.string.artifactsSemanticsPrevious: StringResource by lazy {
      StringResource("string:artifactsSemanticsPrevious", "artifactsSemanticsPrevious", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2240, 86),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1440, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1464, 58),
      ))
    }

@delegate:ResourceContentHash(1_050_684_685)
internal val Res.string.artifactsTitleArtifacts: StringResource by lazy {
      StringResource("string:artifactsTitleArtifacts", "artifactsTitleArtifacts", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2327, 71),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1495, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1523, 43),
      ))
    }

@delegate:ResourceContentHash(-515_279_301)
internal val Res.string.bottomScrubberSemanticScrubber: StringResource by lazy {
      StringResource("string:bottomScrubberSemanticScrubber", "bottomScrubberSemanticScrubber", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2399, 66),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1535, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1567, 50),
      ))
    }

@delegate:ResourceContentHash(66_861_691)
internal val Res.string.bottomScrubberSemanticTimeline: StringResource by lazy {
      StringResource("string:bottomScrubberSemanticTimeline", "bottomScrubberSemanticTimeline", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2466, 294),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1586, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1618, 122),
      ))
    }

@delegate:ResourceContentHash(-1_584_967_549)
internal val Res.string.chichenItza1100ce: StringResource by lazy {
      StringResource("string:chichenItza1100ce", "chichenItza1100ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2761, 205),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1709, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1741, 81),
      ))
    }

@delegate:ResourceContentHash(-2_137_521_172)
internal val Res.string.chichenItza1527ce: StringResource by lazy {
      StringResource("string:chichenItza1527ce", "chichenItza1527ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2967, 213),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1787, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1823, 97),
      ))
    }

@delegate:ResourceContentHash(284_662_338)
internal val Res.string.chichenItza1535ce: StringResource by lazy {
      StringResource("string:chichenItza1535ce", "chichenItza1535ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3181, 229),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1889, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1921, 93),
      ))
    }

@delegate:ResourceContentHash(-61_068_250)
internal val Res.string.chichenItza600ce: StringResource by lazy {
      StringResource("string:chichenItza600ce", "chichenItza600ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3411, 328),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1963, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2015, 136),
      ))
    }

@delegate:ResourceContentHash(1_602_130_201)
internal val Res.string.chichenItza832ce: StringResource by lazy {
      StringResource("string:chichenItza832ce", "chichenItza832ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3740, 208),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2076, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2152, 100),
      ))
    }

@delegate:ResourceContentHash(-1_526_584_537)
internal val Res.string.chichenItza998ce: StringResource by lazy {
      StringResource("string:chichenItza998ce", "chichenItza998ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3949, 164),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2157, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2253, 84),
      ))
    }

@delegate:ResourceContentHash(-1_425_647_461)
internal val Res.string.chichenItzaArtifactCulture: StringResource by lazy {
      StringResource("string:chichenItzaArtifactCulture", "chichenItzaArtifactCulture", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4114, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2238, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2338, 42),
      ))
    }

@delegate:ResourceContentHash(695_312_797)
internal val Res.string.chichenItzaArtifactGeolocation: StringResource by lazy {
      StringResource("string:chichenItzaArtifactGeolocation", "chichenItzaArtifactGeolocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4165, 114),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2281, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2381, 74),
      ))
    }

@delegate:ResourceContentHash(-1_673_056_740)
internal val Res.string.chichenItzaCallout1: StringResource by lazy {
      StringResource("string:chichenItzaCallout1", "chichenItzaCallout1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4280, 595),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2348, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2456, 247),
      ))
    }

@delegate:ResourceContentHash(-37_539_895)
internal val Res.string.chichenItzaCallout2: StringResource by lazy {
      StringResource("string:chichenItzaCallout2", "chichenItzaCallout2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 4876, 355),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2560, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2704, 155),
      ))
    }

@delegate:ResourceContentHash(234_016_722)
internal val Res.string.chichenItzaCollectible1Icon: StringResource by lazy {
      StringResource("string:chichenItzaCollectible1Icon", "chichenItzaCollectible1Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5232, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2688, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2860, 47),
      ))
    }

@delegate:ResourceContentHash(948_681_657)
internal val Res.string.chichenItzaCollectible1Title: StringResource by lazy {
      StringResource("string:chichenItzaCollectible1Title", "chichenItzaCollectible1Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5288, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2732, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2908, 48),
      ))
    }

@delegate:ResourceContentHash(234_016_722)
internal val Res.string.chichenItzaCollectible2Icon: StringResource by lazy {
      StringResource("string:chichenItzaCollectible2Icon", "chichenItzaCollectible2Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5341, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2777, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2957, 47),
      ))
    }

@delegate:ResourceContentHash(25_218_783)
internal val Res.string.chichenItzaCollectible2Title: StringResource by lazy {
      StringResource("string:chichenItzaCollectible2Title", "chichenItzaCollectible2Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5397, 80),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2821, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3005, 56),
      ))
    }

@delegate:ResourceContentHash(116_452_027)
internal val Res.string.chichenItzaCollectible3Icon: StringResource by lazy {
      StringResource("string:chichenItzaCollectible3Icon", "chichenItzaCollectible3Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5478, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2870, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3062, 47),
      ))
    }

@delegate:ResourceContentHash(1_527_149_126)
internal val Res.string.chichenItzaCollectible3Title: StringResource by lazy {
      StringResource("string:chichenItzaCollectible3Title", "chichenItzaCollectible3Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5534, 136),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2914, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3110, 72),
      ))
    }

@delegate:ResourceContentHash(44_715_902)
internal val Res.string.chichenItzaConstructionInfo1: StringResource by lazy {
      StringResource("string:chichenItzaConstructionInfo1", "chichenItzaConstructionInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 5671, 1612),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2987, 620),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3183, 672),
      ))
    }

@delegate:ResourceContentHash(2_020_550_774)
internal val Res.string.chichenItzaConstructionInfo2: StringResource by lazy {
      StringResource("string:chichenItzaConstructionInfo2", "chichenItzaConstructionInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 7284, 828),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3608, 408),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3856, 328),
      ))
    }

@delegate:ResourceContentHash(1_055_121_224)
internal val Res.string.chichenItzaHistoryInfo1: StringResource by lazy {
      StringResource("string:chichenItzaHistoryInfo1", "chichenItzaHistoryInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 8113, 1571),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4017, 655),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4185, 635),
      ))
    }

@delegate:ResourceContentHash(-2_039_888_983)
internal val Res.string.chichenItzaHistoryInfo2: StringResource by lazy {
      StringResource("string:chichenItzaHistoryInfo2", "chichenItzaHistoryInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 9685, 475),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4673, 199),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4821, 223),
      ))
    }

@delegate:ResourceContentHash(969_150_947)
internal val Res.string.chichenItzaLocationInfo1: StringResource by lazy {
      StringResource("string:chichenItzaLocationInfo1", "chichenItzaLocationInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10161, 792),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4873, 304),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5045, 324),
      ))
    }

@delegate:ResourceContentHash(-393_242_242)
internal val Res.string.chichenItzaLocationInfo2: StringResource by lazy {
      StringResource("string:chichenItzaLocationInfo2", "chichenItzaLocationInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10954, 584),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5178, 256),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5370, 260),
      ))
    }

@delegate:ResourceContentHash(-687_715_199)
internal val Res.string.chichenItzaMapCaption: StringResource by lazy {
      StringResource("string:chichenItzaMapCaption", "chichenItzaMapCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11539, 269),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5435, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5631, 113),
      ))
    }

@delegate:ResourceContentHash(2_011_018_566)
internal val Res.string.chichenItzaPullQuote1Bottom: StringResource by lazy {
      StringResource("string:chichenItzaPullQuote1Bottom", "chichenItzaPullQuote1Bottom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11809, 87),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5541, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5745, 75),
      ))
    }

@delegate:ResourceContentHash(-829_214_669)
internal val Res.string.chichenItzaPullQuote1Top: StringResource by lazy {
      StringResource("string:chichenItzaPullQuote1Top", "chichenItzaPullQuote1Top", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11897, 96),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5597, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5821, 56),
      ))
    }

@delegate:ResourceContentHash(795_206_983)
internal val Res.string.chichenItzaPullQuote2: StringResource by lazy {
      StringResource("string:chichenItzaPullQuote2", "chichenItzaPullQuote2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12062, 417),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5718, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5922, 181),
      ))
    }

@delegate:ResourceContentHash(-1_603_625_081)
internal val Res.string.chichenItzaPullQuote2Author: StringResource by lazy {
      StringResource("string:chichenItzaPullQuote2Author", "chichenItzaPullQuote2Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11994, 67),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5650, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5878, 43),
      ))
    }

@delegate:ResourceContentHash(-1_100_710_927)
internal val Res.string.chichenItzaRegionTitle: StringResource by lazy {
      StringResource("string:chichenItzaRegionTitle", "chichenItzaRegionTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12480, 90),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5904, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6104, 50),
      ))
    }

@delegate:ResourceContentHash(1_170_243_019)
internal val Res.string.chichenItzaSubTitle: StringResource by lazy {
      StringResource("string:chichenItzaSubTitle", "chichenItzaSubTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12571, 67),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 5967, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6155, 55),
      ))
    }

@delegate:ResourceContentHash(-508_594_228)
internal val Res.string.chichenItzaTitle: StringResource by lazy {
      StringResource("string:chichenItzaTitle", "chichenItzaTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12639, 72),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6023, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6211, 40),
      ))
    }

@delegate:ResourceContentHash(-1_795_665_285)
internal val Res.string.chichenItzaVideoCaption: StringResource by lazy {
      StringResource("string:chichenItzaVideoCaption", "chichenItzaVideoCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12712, 343),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6064, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6252, 147),
      ))
    }

@delegate:ResourceContentHash(-899_088_540)
internal val Res.string.christRedeemer1850ce: StringResource by lazy {
      StringResource("string:christRedeemer1850ce", "christRedeemer1850ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13056, 496),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6188, 204),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6400, 184),
      ))
    }

@delegate:ResourceContentHash(1_661_101_060)
internal val Res.string.christRedeemer1921ce: StringResource by lazy {
      StringResource("string:christRedeemer1921ce", "christRedeemer1921ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13553, 616),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6393, 200),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6585, 228),
      ))
    }

@delegate:ResourceContentHash(2_081_211_331)
internal val Res.string.christRedeemer1922ce: StringResource by lazy {
      StringResource("string:christRedeemer1922ce", "christRedeemer1922ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14170, 356),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6594, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6814, 176),
      ))
    }

@delegate:ResourceContentHash(1_120_835_900)
internal val Res.string.christRedeemer1926ce: StringResource by lazy {
      StringResource("string:christRedeemer1926ce", "christRedeemer1926ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14527, 608),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6715, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6991, 204),
      ))
    }

@delegate:ResourceContentHash(-2_000_668_797)
internal val Res.string.christRedeemer1931ce: StringResource by lazy {
      StringResource("string:christRedeemer1931ce", "christRedeemer1931ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15136, 276),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6888, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7196, 148),
      ))
    }

@delegate:ResourceContentHash(946_474_754)
internal val Res.string.christRedeemer2006ce: StringResource by lazy {
      StringResource("string:christRedeemer2006ce", "christRedeemer2006ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15413, 432),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 6993, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7345, 180),
      ))
    }

@delegate:ResourceContentHash(-1_345_216_999)
internal val Res.string.christRedeemerArtifactGeolocation: StringResource by lazy {
      StringResource("string:christRedeemerArtifactGeolocation", "christRedeemerArtifactGeolocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15846, 69),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7162, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7526, 49),
      ))
    }

@delegate:ResourceContentHash(1_876_932_578)
internal val Res.string.christRedeemerCallout1: StringResource by lazy {
      StringResource("string:christRedeemerCallout1", "christRedeemerCallout1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15916, 270),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7212, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7576, 138),
      ))
    }

@delegate:ResourceContentHash(389_365_717)
internal val Res.string.christRedeemerCallout2: StringResource by lazy {
      StringResource("string:christRedeemerCallout2", "christRedeemerCallout2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16187, 398),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7331, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7715, 254),
      ))
    }

@delegate:ResourceContentHash(-1_548_861_282)
internal val Res.string.christRedeemerCollectible1Icon: StringResource by lazy {
      StringResource("string:christRedeemerCollectible1Icon", "christRedeemerCollectible1Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16586, 66),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7546, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7970, 46),
      ))
    }

@delegate:ResourceContentHash(-319_572_374)
internal val Res.string.christRedeemerCollectible1Title: StringResource by lazy {
      StringResource("string:christRedeemerCollectible1Title", "christRedeemerCollectible1Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16653, 99),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7593, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8017, 59),
      ))
    }

@delegate:ResourceContentHash(234_016_722)
internal val Res.string.christRedeemerCollectible2Icon: StringResource by lazy {
      StringResource("string:christRedeemerCollectible2Icon", "christRedeemerCollectible2Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16753, 58),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7649, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8077, 50),
      ))
    }

@delegate:ResourceContentHash(-1_019_613_267)
internal val Res.string.christRedeemerCollectible2Title: StringResource by lazy {
      StringResource("string:christRedeemerCollectible2Title", "christRedeemerCollectible2Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16812, 83),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7696, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8128, 51),
      ))
    }

@delegate:ResourceContentHash(573_104_081)
internal val Res.string.christRedeemerCollectible3Icon: StringResource by lazy {
      StringResource("string:christRedeemerCollectible3Icon", "christRedeemerCollectible3Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16896, 58),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7752, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8180, 50),
      ))
    }

@delegate:ResourceContentHash(-2_122_719_129)
internal val Res.string.christRedeemerCollectible3Title: StringResource by lazy {
      StringResource("string:christRedeemerCollectible3Title", "christRedeemerCollectible3Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16955, 103),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7799, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8231, 75),
      ))
    }

@delegate:ResourceContentHash(-1_459_466_992)
internal val Res.string.christRedeemerConstructionInfo1: StringResource by lazy {
      StringResource("string:christRedeemerConstructionInfo1", "christRedeemerConstructionInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17059, 1159),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 7879, 463),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8307, 431),
      ))
    }

@delegate:ResourceContentHash(-748_532_857)
internal val Res.string.christRedeemerConstructionInfo2: StringResource by lazy {
      StringResource("string:christRedeemerConstructionInfo2", "christRedeemerConstructionInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18219, 1275),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8343, 447),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8739, 491),
      ))
    }

@delegate:ResourceContentHash(-674_924_877)
internal val Res.string.christRedeemerHistoryInfo1: StringResource by lazy {
      StringResource("string:christRedeemerHistoryInfo1", "christRedeemerHistoryInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19495, 1114),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 8791, 406),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9231, 474),
      ))
    }

@delegate:ResourceContentHash(-2_146_742_264)
internal val Res.string.christRedeemerHistoryInfo2: StringResource by lazy {
      StringResource("string:christRedeemerHistoryInfo2", "christRedeemerHistoryInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20610, 1718),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 9198, 650),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9706, 746),
      ))
    }

@delegate:ResourceContentHash(-898_944_748)
internal val Res.string.christRedeemerLocationInfo1: StringResource by lazy {
      StringResource("string:christRedeemerLocationInfo1", "christRedeemerLocationInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22329, 655),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 9849, 295),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10453, 287),
      ))
    }

@delegate:ResourceContentHash(1_464_071_011)
internal val Res.string.christRedeemerLocationInfo2: StringResource by lazy {
      StringResource("string:christRedeemerLocationInfo2", "christRedeemerLocationInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22985, 467),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10145, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10741, 195),
      ))
    }

@delegate:ResourceContentHash(-762_095_380)
internal val Res.string.christRedeemerMapCaption: StringResource by lazy {
      StringResource("string:christRedeemerMapCaption", "christRedeemerMapCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23453, 276),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10325, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10937, 128),
      ))
    }

@delegate:ResourceContentHash(-452_758_178)
internal val Res.string.christRedeemerPullQuote1Bottom: StringResource by lazy {
      StringResource("string:christRedeemerPullQuote1Bottom", "christRedeemerPullQuote1Bottom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23730, 114),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10438, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11066, 70),
      ))
    }

@delegate:ResourceContentHash(1_077_895_301)
internal val Res.string.christRedeemerPullQuote1Top: StringResource by lazy {
      StringResource("string:christRedeemerPullQuote1Top", "christRedeemerPullQuote1Top", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23845, 179),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10493, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11137, 67),
      ))
    }

@delegate:ResourceContentHash(497_285_061)
internal val Res.string.christRedeemerPullQuote2: StringResource by lazy {
      StringResource("string:christRedeemerPullQuote2", "christRedeemerPullQuote2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24104, 504),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10620, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11260, 196),
      ))
    }

@delegate:ResourceContentHash(-1_623_815_458)
internal val Res.string.christRedeemerPullQuote2Author: StringResource by lazy {
      StringResource("string:christRedeemerPullQuote2Author", "christRedeemerPullQuote2Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24025, 78),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10553, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11205, 54),
      ))
    }

@delegate:ResourceContentHash(-1_355_565_185)
internal val Res.string.christRedeemerRegionTitle: StringResource by lazy {
      StringResource("string:christRedeemerRegionTitle", "christRedeemerRegionTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24609, 121),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10769, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11457, 65),
      ))
    }

@delegate:ResourceContentHash(1_302_194_703)
internal val Res.string.christRedeemerSubTitle: StringResource by lazy {
      StringResource("string:christRedeemerSubTitle", "christRedeemerSubTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24731, 86),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10835, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11523, 54),
      ))
    }

@delegate:ResourceContentHash(1_202_560_656)
internal val Res.string.christRedeemerTitle: StringResource by lazy {
      StringResource("string:christRedeemerTitle", "christRedeemerTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24818, 91),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10886, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11578, 55),
      ))
    }

@delegate:ResourceContentHash(697_926_060)
internal val Res.string.christRedeemerVideoCaption: StringResource by lazy {
      StringResource("string:christRedeemerVideoCaption", "christRedeemerVideoCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24910, 474),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10934, 270),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11634, 242),
      ))
    }

@delegate:ResourceContentHash(1_335_633_002)
internal val Res.string.circleButtonsSemanticBack: StringResource by lazy {
      StringResource("string:circleButtonsSemanticBack", "circleButtonsSemanticBack", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25385, 49),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11205, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11877, 41),
      ))
    }

@delegate:ResourceContentHash(-1_469_718_110)
internal val Res.string.circleButtonsSemanticClose: StringResource by lazy {
      StringResource("string:circleButtonsSemanticClose", "circleButtonsSemanticClose", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25435, 66),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11247, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11919, 42),
      ))
    }

@delegate:ResourceContentHash(-227_067_081)
internal val Res.string.collectibleFoundButtonViewCollection: StringResource by lazy {
      StringResource("string:collectibleFoundButtonViewCollection", "collectibleFoundButtonViewCollection", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25502, 120),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11290, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11962, 72),
      ))
    }

@delegate:ResourceContentHash(401_903_548)
internal val Res.string.collectibleFoundTitleArtifactDiscovered: StringResource by lazy {
      StringResource("string:collectibleFoundTitleArtifactDiscovered", "collectibleFoundTitleArtifactDiscovered", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25623, 103),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11367, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12035, 75),
      ))
    }

@delegate:ResourceContentHash(161_774_686)
internal val Res.string.collectibleItemSemanticCollectible: StringResource by lazy {
      StringResource("string:collectibleItemSemanticCollectible", "collectibleItemSemanticCollectible", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25727, 98),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11439, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12111, 66),
      ))
    }

@delegate:ResourceContentHash(624_175_737)
internal val Res.string.collectionButtonReset: StringResource by lazy {
      StringResource("string:collectionButtonReset", "collectionButtonReset", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25826, 93),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11498, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12178, 53),
      ))
    }

@delegate:ResourceContentHash(1_262_711_241)
internal val Res.string.collectionLabelCount: StringResource by lazy {
      StringResource("string:collectionLabelCount", "collectionLabelCount", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25920, 64),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11548, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12232, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("animatedArrowSemanticSwipe", Res.string.animatedArrowSemanticSwipe)
  map.put("appBarTitleConstruction", Res.string.appBarTitleConstruction)
  map.put("appBarTitleFactsHistory", Res.string.appBarTitleFactsHistory)
  map.put("appBarTitleLocation", Res.string.appBarTitleLocation)
  map.put("appModalsButtonCancel", Res.string.appModalsButtonCancel)
  map.put("appModalsButtonOk", Res.string.appModalsButtonOk)
  map.put("appName", Res.string.appName)
  map.put("appPageDefaultTitlePage", Res.string.appPageDefaultTitlePage)
  map.put("appPageSemanticSwipe", Res.string.appPageSemanticSwipe)
  map.put("artifactDetailsErrorNotFound", Res.string.artifactDetailsErrorNotFound)
  map.put("artifactDetailsLabelClassification", Res.string.artifactDetailsLabelClassification)
  map.put("artifactDetailsLabelDate", Res.string.artifactDetailsLabelDate)
  map.put("artifactDetailsLabelDimension", Res.string.artifactDetailsLabelDimension)
  map.put("artifactDetailsLabelGeography", Res.string.artifactDetailsLabelGeography)
  map.put("artifactDetailsLabelMedium", Res.string.artifactDetailsLabelMedium)
  map.put("artifactDetailsLabelPeriod", Res.string.artifactDetailsLabelPeriod)
  map.put("artifactDetailsSemanticThumbnail", Res.string.artifactDetailsSemanticThumbnail)
  map.put("artifactsButtonBrowse", Res.string.artifactsButtonBrowse)
  map.put("artifactsSearchButtonToggle", Res.string.artifactsSearchButtonToggle)
  map.put("artifactsSearchLabelAdjust", Res.string.artifactsSearchLabelAdjust)
  map.put("artifactsSearchLabelFound", Res.string.artifactsSearchLabelFound)
  map.put("artifactsSearchLabelNotFound", Res.string.artifactsSearchLabelNotFound)
  map.put("artifactsSearchLabelSearch", Res.string.artifactsSearchLabelSearch)
  map.put("artifactsSearchLabelTimeframe", Res.string.artifactsSearchLabelTimeframe)
  map.put("artifactsSearchSemanticTimeframe", Res.string.artifactsSearchSemanticTimeframe)
  map.put("artifactsSearchTitleBrowse", Res.string.artifactsSearchTitleBrowse)
  map.put("artifactsSemanticArtifact", Res.string.artifactsSemanticArtifact)
  map.put("artifactsSemanticsNext", Res.string.artifactsSemanticsNext)
  map.put("artifactsSemanticsPrevious", Res.string.artifactsSemanticsPrevious)
  map.put("artifactsTitleArtifacts", Res.string.artifactsTitleArtifacts)
  map.put("bottomScrubberSemanticScrubber", Res.string.bottomScrubberSemanticScrubber)
  map.put("bottomScrubberSemanticTimeline", Res.string.bottomScrubberSemanticTimeline)
  map.put("chichenItza1100ce", Res.string.chichenItza1100ce)
  map.put("chichenItza1527ce", Res.string.chichenItza1527ce)
  map.put("chichenItza1535ce", Res.string.chichenItza1535ce)
  map.put("chichenItza600ce", Res.string.chichenItza600ce)
  map.put("chichenItza832ce", Res.string.chichenItza832ce)
  map.put("chichenItza998ce", Res.string.chichenItza998ce)
  map.put("chichenItzaArtifactCulture", Res.string.chichenItzaArtifactCulture)
  map.put("chichenItzaArtifactGeolocation", Res.string.chichenItzaArtifactGeolocation)
  map.put("chichenItzaCallout1", Res.string.chichenItzaCallout1)
  map.put("chichenItzaCallout2", Res.string.chichenItzaCallout2)
  map.put("chichenItzaCollectible1Icon", Res.string.chichenItzaCollectible1Icon)
  map.put("chichenItzaCollectible1Title", Res.string.chichenItzaCollectible1Title)
  map.put("chichenItzaCollectible2Icon", Res.string.chichenItzaCollectible2Icon)
  map.put("chichenItzaCollectible2Title", Res.string.chichenItzaCollectible2Title)
  map.put("chichenItzaCollectible3Icon", Res.string.chichenItzaCollectible3Icon)
  map.put("chichenItzaCollectible3Title", Res.string.chichenItzaCollectible3Title)
  map.put("chichenItzaConstructionInfo1", Res.string.chichenItzaConstructionInfo1)
  map.put("chichenItzaConstructionInfo2", Res.string.chichenItzaConstructionInfo2)
  map.put("chichenItzaHistoryInfo1", Res.string.chichenItzaHistoryInfo1)
  map.put("chichenItzaHistoryInfo2", Res.string.chichenItzaHistoryInfo2)
  map.put("chichenItzaLocationInfo1", Res.string.chichenItzaLocationInfo1)
  map.put("chichenItzaLocationInfo2", Res.string.chichenItzaLocationInfo2)
  map.put("chichenItzaMapCaption", Res.string.chichenItzaMapCaption)
  map.put("chichenItzaPullQuote1Bottom", Res.string.chichenItzaPullQuote1Bottom)
  map.put("chichenItzaPullQuote1Top", Res.string.chichenItzaPullQuote1Top)
  map.put("chichenItzaPullQuote2", Res.string.chichenItzaPullQuote2)
  map.put("chichenItzaPullQuote2Author", Res.string.chichenItzaPullQuote2Author)
  map.put("chichenItzaRegionTitle", Res.string.chichenItzaRegionTitle)
  map.put("chichenItzaSubTitle", Res.string.chichenItzaSubTitle)
  map.put("chichenItzaTitle", Res.string.chichenItzaTitle)
  map.put("chichenItzaVideoCaption", Res.string.chichenItzaVideoCaption)
  map.put("christRedeemer1850ce", Res.string.christRedeemer1850ce)
  map.put("christRedeemer1921ce", Res.string.christRedeemer1921ce)
  map.put("christRedeemer1922ce", Res.string.christRedeemer1922ce)
  map.put("christRedeemer1926ce", Res.string.christRedeemer1926ce)
  map.put("christRedeemer1931ce", Res.string.christRedeemer1931ce)
  map.put("christRedeemer2006ce", Res.string.christRedeemer2006ce)
  map.put("christRedeemerArtifactGeolocation", Res.string.christRedeemerArtifactGeolocation)
  map.put("christRedeemerCallout1", Res.string.christRedeemerCallout1)
  map.put("christRedeemerCallout2", Res.string.christRedeemerCallout2)
  map.put("christRedeemerCollectible1Icon", Res.string.christRedeemerCollectible1Icon)
  map.put("christRedeemerCollectible1Title", Res.string.christRedeemerCollectible1Title)
  map.put("christRedeemerCollectible2Icon", Res.string.christRedeemerCollectible2Icon)
  map.put("christRedeemerCollectible2Title", Res.string.christRedeemerCollectible2Title)
  map.put("christRedeemerCollectible3Icon", Res.string.christRedeemerCollectible3Icon)
  map.put("christRedeemerCollectible3Title", Res.string.christRedeemerCollectible3Title)
  map.put("christRedeemerConstructionInfo1", Res.string.christRedeemerConstructionInfo1)
  map.put("christRedeemerConstructionInfo2", Res.string.christRedeemerConstructionInfo2)
  map.put("christRedeemerHistoryInfo1", Res.string.christRedeemerHistoryInfo1)
  map.put("christRedeemerHistoryInfo2", Res.string.christRedeemerHistoryInfo2)
  map.put("christRedeemerLocationInfo1", Res.string.christRedeemerLocationInfo1)
  map.put("christRedeemerLocationInfo2", Res.string.christRedeemerLocationInfo2)
  map.put("christRedeemerMapCaption", Res.string.christRedeemerMapCaption)
  map.put("christRedeemerPullQuote1Bottom", Res.string.christRedeemerPullQuote1Bottom)
  map.put("christRedeemerPullQuote1Top", Res.string.christRedeemerPullQuote1Top)
  map.put("christRedeemerPullQuote2", Res.string.christRedeemerPullQuote2)
  map.put("christRedeemerPullQuote2Author", Res.string.christRedeemerPullQuote2Author)
  map.put("christRedeemerRegionTitle", Res.string.christRedeemerRegionTitle)
  map.put("christRedeemerSubTitle", Res.string.christRedeemerSubTitle)
  map.put("christRedeemerTitle", Res.string.christRedeemerTitle)
  map.put("christRedeemerVideoCaption", Res.string.christRedeemerVideoCaption)
  map.put("circleButtonsSemanticBack", Res.string.circleButtonsSemanticBack)
  map.put("circleButtonsSemanticClose", Res.string.circleButtonsSemanticClose)
  map.put("collectibleFoundButtonViewCollection", Res.string.collectibleFoundButtonViewCollection)
  map.put("collectibleFoundTitleArtifactDiscovered", Res.string.collectibleFoundTitleArtifactDiscovered)
  map.put("collectibleItemSemanticCollectible", Res.string.collectibleItemSemanticCollectible)
  map.put("collectionButtonReset", Res.string.collectionButtonReset)
  map.put("collectionLabelCount", Res.string.collectionLabelCount)
}
